import { useMutation } from '@tanstack/react-query';
import API from 'api/API';

type Payload = Parameters<typeof API.contact.sendSubscriptionUpgradeRequest>[0];

export const useSendSubscriptionUpgradeRequest = () => {
  return useMutation({
    mutationFn: (payload: Payload) => API.contact.sendSubscriptionUpgradeRequest(payload),
    meta: { ignoreGlobalError: true },
  });
};
